<template>
  <div class="zmlawtj">
    <div class="ti">{{ zmlawbt }}</div>
    <div class="lawlist mt30 between">
      <div class="tjlawitem" v-for="item in 3" :key="item">
        <div class="tlim flex_start">
          <div class="cover">
            <img src="../../../assets/zuimindetail/rt_sample.png" alt="" />
          </div>
          <div class="rtext">
            <div class="name">XX律师</div>
            <div class="tag mt10 ellipsis">刑事辩护 交通事故</div>
            <div class="dh mt10 flex_start">
              <img src="../../../assets/zuimindetail/thlawdianhua.png" alt="" />
              188-9555-555
            </div>
          </div>
        </div>
        <div class="tlim2">
          <div class="between">
            <div class="name">XX <span>专职律师</span></div>
            <div class="adress flex_end">
              <img src="../../../assets/zuimindetail/icon_adress.png" alt="" />
              安徽-合肥
            </div>
          </div>
          <div class="des">
            毕业于西南政法大学刑法学专业，执业于安徽金华安律师事务所。
          </div>
          <div class="onlzxbtn">在线咨询</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    zmlawbt: {
      type: String,
      default: "合肥刑事辩护律师推荐",
    },
  },
};
</script>

<style lang="scss" scoped>
.zmlawtj {
  padding: 24px 22px;
  .ti {
    font-size: 24px;
    color: #333333;
    line-height: 24px;
  }
  .lawlist {
    .tjlawitem {
      width: 258px;
      height: 150px;
      background: #fefefe;
      background: url("../../../assets/zuimindetail/tjlaw_bg.png");
      border-radius: 2px;
      cursor: pointer;
      &:hover {
        background: #fefefe;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
        .tlim {
          display: none;
        }
        .tlim2 {
          display: block;
        }
      }
      .tlim {
        width: 100%;
        height: 100%;
        padding: 0 20px;
        cursor: pointer;

        .cover {
          margin-right: 15px;
          img {
            width: 72px;
            height: 72px;
            border-radius: 50%;
          }
        }
        .rtext {
          color: #333333;
        }
        .name {
          font-size: 18px;
          line-height: 18px;
        }
        .tag {
          width: 120px;
          font-size: 14px;
          color: #666666;
          line-height: 14px;
        }
        .dh {
          font-size: 14px;
          img {
            width: 14px;
            height: 14px;
            margin-right: 8px;
          }
        }
      }
      .tlim2 {
        display: none;
        padding: 20px 16px;
        padding: 20px 16px;
        .name {
          font-size: 22px;
          line-height: 22px;
          span {
            font-size: 14px;
            color: #666666;
          }
        }
        .adress {
          font-size: 12px;
          img {
            margin-right: 8px;
          }
        }
        .des {
          margin-top: 15px;
          font-size: 12px;
          color: #666666;
          line-height: 20px;
        }
        .onlzxbtn {
          margin: 10px auto 0;
          width: 96px;
          height: 26px;
          text-align: center;
          line-height: 26px;
          background: #f2561b;
          border-radius: 13px;
          font-size: 14px;
          color: #ffffff;
        }
      }
    }
  }
}
</style>